// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"a3058edc","318":"b17dde28"}[chunkId] + ".chunk.js";
};